import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { AlertService } from '@app/_services';
import { ActivityWishlistService } from '../activity-wishlist.service';
import { ActivityWishlist } from '../activity-wishlist';

@Component({
    selector: 'app-activity-wishlist-list',
    templateUrl: './activity-wishlist-list.component.html',
    styleUrls: ['./activity-wishlist-list.component.css'],
    providers: [MessageService, ConfirmationService],
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
    `],
    standalone: false
})
export class ActivityWishlistListComponent implements OnInit {

    wishlists: ActivityWishlist[] = [];
    wishlist: ActivityWishlist;

    // paging
    first = 0;
    rows = 50;
    recordTotal: number;
    loading = true;
    multiSortMeta = [];
    lazyLoadEvent: LazyLoadEvent;
    datasource: any;

    statuses: any[];

    statusFilter: any;

    constructor(
        private wishlistService: ActivityWishlistService,
        private alertService: AlertService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private router: Router
    ) {
        this.statuses = wishlistService.statuses;
    }

    ngOnInit(): void {
        this.multiSortMeta = [];
        this.multiSortMeta.push({ field: 'createDate', order: -1 });
    }

    loadLazy(event: LazyLoadEvent) {
        try {
            this.loading = true;
            this.lazyLoadEvent = event;

            if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
                event.multiSortMeta = [];
                event.multiSortMeta.push({ field: 'createDate', order: -1 });
            }

            const pageNumber = Math.round(event.first / event.rows);
            this.wishlistService.findByFilter(
                pageNumber, event.rows,
                event.sortField,
                event.sortOrder,
                event.multiSortMeta,
                event.globalFilter,
                event.filters
            ).pipe(first()).subscribe(
                (res: any) => {
                    this.wishlists = res.data.activityWishlists || res.data.wishlists || [];
                    this.recordTotal = res.page ? res.page.recordTotal : 0;
                },
                (err: any) => {
                    console.error('activity-wishlist list error:', err);
                    this.alertService.error(err);
                },
                () => { this.loading = false; }
            );
        } catch (error) {
            console.error('loadLazy error:', error);
        }
    }

    onRowSelect(event: any) {
        this.router.navigate(['activity-wishlists', event.data.wishlistId]);
    }

    getStatusSeverity(status: string): string {
        switch (status) {
            case 'submitted':  return 'warning';
            case 'suggested':  return 'info';
            case 'viewed':     return 'secondary';
            case 'confirmed':  return 'success';
            case 'processing': return 'help';
            case 'completed':  return 'secondary';
            default:           return 'secondary';
        }
    }

    onRowDelete(event: any) {
        this.confirmationService.confirm({
            message: 'Are you sure you want to delete wishlist #' + event.wishlistId + '?',
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.wishlistService.delete(event.wishlistId).pipe(first()).subscribe(
                    (res: any) => {
                        this.wishlists = this.wishlists.filter(w => w.wishlistId !== event.wishlistId);
                        this.messageService.add({ severity: 'success', summary: 'Deleted', detail: 'Wishlist deleted.', life: 3000 });
                    },
                    (err: any) => {
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not delete.', life: 3000 });
                    }
                );
            },
            reject: () => {
                this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
            }
        });
    }

    reloadPage() {
        window.location.reload();
    }
}
